import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    timeout: { type: Number, default: 5000 },
    testMode: { type: Boolean, default: false }
  }

  connect() {
    console.log("Alert controller connected");

    // Check if we're in a test environment
    this.isTestEnvironment = window.Capybara ||
                             /HeadlessChrome/.test(navigator.userAgent) ||
                             this.testModeValue;

    // Only auto-dismiss if timeout is greater than zero and not in test environment
    if (this.timeoutValue > 0 && !this.isTestEnvironment) {
      this.dismissTimeout = setTimeout(() => {
        this.close()
      }, this.timeoutValue)
    }
  }

  disconnect() {
    // Clear timeout if element is removed from DOM
    if (this.dismissTimeout) {
      clearTimeout(this.dismissTimeout)
    }
  }

  close(event) {
    if (event) event.preventDefault();

    // Add a fade-out class for animation
    this.element.classList.add('opacity-0')

    // Set a data attribute for testing
    this.element.dataset.alertState = "closing";

    // In test environment, remove immediately to avoid animation delays
    if (this.isTestEnvironment) {
      this.element.remove();
      return;
    }

    // Remove element after animation completes
    setTimeout(() => {
      this.element.remove()
    }, 300) // Animation duration
  }
}